export const bgButtonsColors = [
  '#96BB63',
  '#63BBBB',
  '#8280EB',
  '#EEA159',
  '#EE5959',
  '#4E5FFF'
]
